import { apiRequest } from "./api";

const TOKEN_KEY = "govzy_token";
const USER_KEY = "govzy_user";

export function clearSession() {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(USER_KEY);
}

export function loadSession() {
  const token = localStorage.getItem(TOKEN_KEY);
  const serializedUser = localStorage.getItem(USER_KEY);

  if (!token || !serializedUser) {
    if (token || serializedUser) clearSession();
    return null;
  }

  try {
    const user = JSON.parse(serializedUser);
    if (!user || typeof user !== "object" || Array.isArray(user)) {
      clearSession();
      return null;
    }
    return { token, user };
  } catch (error) {
    clearSession();
    return null;
  }
}

export function saveSession({ token, user }) {
  localStorage.setItem(TOKEN_KEY, token);
  localStorage.setItem(USER_KEY, JSON.stringify(user));
}

export async function restoreSession(request = apiRequest) {
  const session = loadSession();
  if (!session) return null;

  try {
    const response = await request("/api/auth/me", { token: session.token });
    if (!response.ok) {
      if (response.status === 401) clearSession();
      return null;
    }

    if (typeof response.json !== "function") return session;
    const body = await response.json();
    const user = body?.user || body;
    if (!user || typeof user !== "object" || Array.isArray(user)) return session;

    const restored = { token: session.token, user };
    saveSession(restored);
    return restored;
  } catch (error) {
    return null;
  }
}
